import { Wizard } from '../../../components/Wizard/Wizard';
import { useFlag } from '../../../services/launchDarkly';
import ChooseCountry from '../ChooseCountryDialog/ChooseCountry';
import { EmailVerification } from '../EmailVerification/EmailVerification';
import { LogIn } from '../LogIn/LogIn';
import { VerificationSuccess } from '../VerificationSuccess/VerificationSuccess';
import WelcomeBonusDialog from '../WelcomeBonusDialog/WelcomeBonusDialog';

const DEFAULT_STEPS = [LogIn, EmailVerification, VerificationSuccess, WelcomeBonusDialog];

const STEPS_WITH_COUNTRY_SELECTION = [...DEFAULT_STEPS, ChooseCountry];

export default function LogInWizard() {
  const isSignUpCountrySelectionEnabled = useFlag<boolean>('sign_up_flow_country_selection', false);

  const steps = isSignUpCountrySelectionEnabled ? STEPS_WITH_COUNTRY_SELECTION : DEFAULT_STEPS;

  return <Wizard steps={steps} wrapperStyle={{ overflow: 'hidden' }} />;
}
